module.exports = __webpack_public_path__ + "static/browser-1-dd27e481672ff45d3c853943ad5d3f8a.webp";